import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/competences")({
  staticData: {
    permission: PERMISSIONS.RH.PERSONNE.VIEW, // Competences managed under Personne
  },
  component: () => <Outlet />,
});
